/**
 * Standalone Care Refresh eligibility modal.
 * Intercepts product-form ATC for Care Refresh plans only (PDP + collection).
 * Device upsell stays in care-refresh.js.
 */
(function () {
  'use strict';
  if (window.__d1CreEligibilityScriptLoaded) return;
  window.__d1CreEligibilityScriptLoaded = true;

  var OVERSEAS = { 'DJI China': true, TaoBao: true, AliExpress: true };
  var MS_DAY = 86400000;

  var modal = null;
  var pendingForm = null;
  var pendingButton = null;
  var pendingConfig = null;
  var lastFocus = null;
  var adding = false;
  var lockScrollY = 0;

  function isoToday() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    return toIsoDate(d);
  }

  function toIsoDate(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }

  function daysBetween(dateStr) {
    var then = new Date(dateStr + 'T00:00:00');
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    return Math.round((now - then) / MS_DAY);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function daysPhrase(days) {
    if (days === 0) return 'today';
    if (days === 1) return 'yesterday';
    return days + ' days ago';
  }

  function evaluateEligibility(input) {
    if (OVERSEAS[input.retailer]) {
      return {
        ok: false,
        code: 'overseas',
        title: 'This stock isn’t covered',
        message:
          'Care Refresh from D1 Store only works on products bought from an Australian retailer, or from DJI Australia. DJI China, TaoBao, and AliExpress units aren’t eligible.',
      };
    }
    if (input.notActivated) {
      return {
        ok: true,
        code: 'not_activated',
        title: 'You’re good to go',
        message: 'Add Care Refresh now, then set it up in the DJI app as soon as you activate the product.',
      };
    }
    if (!input.activationDate) return { ok: false, code: 'incomplete', title: '', message: '' };

    var days = daysBetween(input.activationDate);
    if (days < 0) {
      return {
        ok: false,
        code: 'future',
        title: 'Pick today or an earlier date',
        message: 'Activation can’t be in the future.',
      };
    }
    if (input.family === 'drone') return evaluateDrone(days);
    return evaluateHandheld(days);
  }

  function evaluateDrone(days) {
    if (days <= 2) {
      return {
        ok: true,
        code: 'ok',
        title: 'You’re good to go',
        message:
          'Activated ' +
          daysPhrase(days) +
          '. Activate Care Refresh in the DJI app within 48 hours of activation.',
      };
    }
    if (days <= 14) {
      return {
        ok: true,
        code: 'beyond_48',
        needsBeyond48: true,
        title: 'We can still add this',
        message: 'It’s been more than 48 hours, so DJI needs a quick extra check. Add to cart and we’ll email you the form.',
      };
    }
    return {
      ok: false,
      code: 'too_late_drone',
      title: 'It’s been more than 14 days',
      message: 'DJI won’t accept Care Refresh on this drone anymore.',
    };
  }

  function evaluateHandheld(days) {
    if (days <= 30) {
      return {
        ok: true,
        code: 'ok',
        title: 'You’re good to go',
        message: 'Handhelds have 30 days after activation. Activate Care Refresh in the DJI app when you’re ready.',
      };
    }
    return {
      ok: false,
      code: 'too_late_handheld',
      title: 'It’s been more than 30 days',
      message: 'DJI won’t accept Care Refresh on this handheld anymore.',
    };
  }

  function familyFromTitle(title) {
    var text = String(title || '').toLowerCase();
    if (/osmo|pocket|action|ronin|gimbal|handheld/.test(text)) return 'handheld';
    return 'drone';
  }

  function selectedPlanPill(scope) {
    if (!scope || typeof scope.querySelector !== 'function') return null;
    return scope.querySelector('[data-d1-plan-pill].is-selected');
  }

  function planNoteFromContext(scope, form) {
    var pill = selectedPlanPill(scope);
    if (!pill && form && form.closest) {
      pill = selectedPlanPill(form.closest('product-info, .product, .card, .card-wrapper'));
    }
    if (pill) {
      var fromPill = pill.getAttribute('data-note');
      if (fromPill) return fromPill;
    }
    var pillsApi = window.D1CardVariantPills;
    if (!pillsApi) return '';
    if (
      (form && typeof pillsApi.comboIdsOf === 'function' && pillsApi.comboIdsOf(form).length >= 2) ||
      (pill && pill.getAttribute('data-combo') === 'true')
    ) {
      return pillsApi.PLAN_NOTE_COMBO || '';
    }
    var label = pill && pill.textContent ? String(pill.textContent) : '';
    if (/1[\s-]*year/i.test(label)) return pillsApi.PLAN_NOTE_1 || '';
    if (/2[\s-]*year/i.test(label)) return pillsApi.PLAN_NOTE_2 || '';
    if (/3[\s-]*year/i.test(label)) return pillsApi.PLAN_NOTE_COMBO || '';
    return '';
  }

  function configFromCard(card) {
    if (!card || typeof card.querySelector !== 'function') return null;
    var node = card.querySelector('[data-d1-care-eligibility]');
    if (node) {
      try {
        var raw = node.tagName === 'SCRIPT' ? node.textContent : node.getAttribute('data-d1-care-eligibility');
        var parsed = JSON.parse(raw);
        if (parsed && parsed.family) return parsed;
      } catch (err) {}
    }
    var titleNode = card.querySelector('.card__heading a, .card__heading');
    var title = titleNode && titleNode.textContent ? String(titleNode.textContent).replace(/\s+/g, ' ').trim() : '';
    if (!/care[\s-]*refresh/i.test(title)) return null;
    var img = card.querySelector('.card__media img, img');
    return {
      family: familyFromTitle(title),
      title: title || 'DJI Care Refresh',
      image: img ? img.currentSrc || img.getAttribute('src') || '' : '',
      beyond48Url: '/pages/care-refresh-beyond-48-hours',
    };
  }

  window.d1CareRefreshEligibility = {
    evaluateEligibility: evaluateEligibility,
    daysBetween: daysBetween,
    familyFromTitle: familyFromTitle,
    configFromCard: configFromCard,
    planNoteFromContext: planNoteFromContext,
    OVERSEAS: OVERSEAS,
  };

  function qs(sel) {
    return modal ? modal.querySelector(sel) : null;
  }

  function modalLabel(name, fallback) {
    if (!modal) return fallback || '';
    var raw = modal.getAttribute(name);
    if (!raw) return fallback || '';
    return raw.replace(/&amp;/g, '&');
  }

  function lockPageScroll() {
    lockScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('cre-modal-open');
    document.body.classList.add('cre-modal-open', 'overflow-hidden');
    document.body.style.top = '-' + lockScrollY + 'px';
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('cre-modal-open');
    document.body.classList.remove('cre-modal-open', 'overflow-hidden');
    document.body.style.top = '';
    window.scrollTo(0, lockScrollY);
  }

  function parseConfig(formEl) {
    if (!formEl) return null;
    var scope = formEl.closest('product-form') || formEl;
    var node =
      formEl.querySelector('[data-d1-care-eligibility]') ||
      scope.querySelector('[data-d1-care-eligibility]');
    if (!node) return null;
    try {
      var raw = node.tagName === 'SCRIPT' ? node.textContent : node.getAttribute('data-d1-care-eligibility');
      var cfg = JSON.parse(raw);
      if (!cfg || !cfg.family) return null;
      return cfg;
    } catch (err) {
      console.warn('Care Refresh eligibility config parse failed', err);
      return null;
    }
  }

  function choiceBtn() {
    return qs('[data-cre-choice-not-activated]');
  }

  function isNotActivated() {
    var btn = choiceBtn();
    return !!(btn && btn.getAttribute('aria-pressed') === 'true');
  }

  function setNotActivated(on) {
    var btn = choiceBtn();
    if (!btn) return;
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function currentInput() {
    var dateInput = qs('#cre-activation-date');
    var retailer = qs('#cre-retailer');
    var emailInput = qs('#cre-customer-email');
    return {
      family: pendingConfig && pendingConfig.family === 'handheld' ? 'handheld' : 'drone',
      notActivated: isNotActivated(),
      activationDate: dateInput && dateInput.value ? dateInput.value : null,
      retailer: retailer && retailer.value ? retailer.value : null,
      email: emailInput ? String(emailInput.value || '').trim() : '',
    };
  }

  function applyPlanNote(note) {
    var el = qs('[data-cre-plan-note]');
    if (!el) return;
    var text = String(note || '').trim();
    el.textContent = text;
    if (text) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function applyFamilyCopy() {
    var handheld = pendingConfig && pendingConfig.family === 'handheld';
    var chipMeta = qs('[data-cre-chip-meta]');
    var dateHint = qs('[data-cre-date-hint]');
    if (chipMeta) {
      chipMeta.textContent = handheld
        ? modalLabel('data-chip-handheld')
        : modalLabel('data-chip-drone');
    }
    if (dateHint) {
      dateHint.textContent = handheld
        ? modalLabel('data-hint-handheld')
        : modalLabel('data-hint-drone');
    }
  }

  function renderStatus() {
    var statusEl = qs('[data-cre-status]');
    var statusTitle = qs('[data-cre-status-title]');
    var statusCopy = qs('[data-cre-status-copy]');
    var submitBtn = qs('[data-cre-submit]');
    var emailCard = qs('[data-cre-email-card]');
    var dateField = qs('[data-cre-date-field]');
    var dateInput = qs('#cre-activation-date');
    if (!statusEl || !submitBtn) return;

    var off = isNotActivated();
    if (dateInput) dateInput.disabled = off;
    if (dateField) dateField.classList.toggle('is-off', off);

    var input = currentInput();
    var result = evaluateEligibility(input);
    var ready = !!(input.retailer && (input.notActivated || input.activationDate));
    var showEmail = !!(result.needsBeyond48 && ready);
    if (emailCard) emailCard.classList.toggle('is-visible', showEmail);

    statusEl.className = 'cre-status';
    if (!ready || result.code === 'incomplete' || adding) {
      if (!adding) {
        statusEl.classList.remove('is-visible');
        if (statusTitle) statusTitle.textContent = '';
        if (statusCopy) statusCopy.textContent = '';
      }
      if (adding) {
        submitBtn.disabled = true;
        submitBtn.textContent = modalLabel('data-submit-adding', 'Adding…');
        return;
      }
      submitBtn.disabled = true;
      submitBtn.textContent = modalLabel('data-submit-idle', 'Select a date and retailer');
      return;
    }

    statusEl.classList.add('is-visible');
    statusEl.classList.add(result.ok ? (result.needsBeyond48 ? 'is-warn' : 'is-ok') : 'is-block');
    if (statusTitle) statusTitle.textContent = result.title;
    if (statusCopy) statusCopy.textContent = result.message;
    var emailOk = !showEmail || isValidEmail(input.email);
    submitBtn.disabled = !result.ok || !emailOk;
    if (result.needsBeyond48) {
      submitBtn.textContent = emailOk
        ? modalLabel('data-submit-beyond')
        : modalLabel('data-submit-email');
    } else if (result.ok) {
      submitBtn.textContent = modalLabel('data-submit-add');
    } else {
      submitBtn.textContent = modalLabel('data-submit-block');
    }
  }

  function resetForm() {
    var dateInput = qs('#cre-activation-date');
    var retailer = qs('#cre-retailer');
    var emailInput = qs('#cre-customer-email');
    var proof = qs('[data-cre-proof]');
    var upload = qs('[data-cre-upload]');
    var uploadTitle = qs('[data-cre-upload-title]');
    var formEl = qs('[data-cre-form]');
    var doneEl = qs('[data-cre-done]');
    adding = false;
    if (dateInput) {
      dateInput.max = isoToday();
      dateInput.value = isoToday();
      dateInput.disabled = false;
    }
    setNotActivated(false);
    if (retailer) retailer.value = '';
    if (emailInput) {
      emailInput.value = (modal.getAttribute('data-customer-email') || '').trim();
    }
    if (proof) proof.value = '';
    if (upload) upload.classList.remove('is-filled');
    if (uploadTitle) {
      uploadTitle.textContent = uploadTitle.getAttribute('data-default-title') || 'Upload receipt';
    }
    if (formEl) formEl.classList.remove('is-hidden');
    if (doneEl) doneEl.classList.remove('is-visible');
    if (modal) modal.classList.remove('is-done');
    renderStatus();
  }

  function openModal(formEl, config) {
    if (!modal) return;
    pendingForm = formEl || null;
    pendingConfig = config;
    lastFocus = document.activeElement;
    var titleEl = qs('[data-cre-chip-title]');
    var thumb = qs('[data-cre-thumb]');
    if (titleEl) titleEl.textContent = config.title || 'DJI Care Refresh';
    if (thumb) {
      if (config.image) {
        thumb.src = config.image;
        thumb.alt = config.title || '';
        thumb.hidden = false;
        thumb.classList.remove('cre-chip__thumb--empty');
      } else {
        thumb.removeAttribute('src');
        thumb.hidden = true;
        thumb.classList.add('cre-chip__thumb--empty');
      }
    }
    applyFamilyCopy();
    applyPlanNote(config && config.planNote);
    resetForm();
    modal.setAttribute('aria-hidden', 'false');
    lockPageScroll();
    var dateInput = qs('#cre-activation-date');
    if (dateInput && !dateInput.disabled) dateInput.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    unlockPageScroll();
    pendingForm = null;
    pendingButton = null;
    pendingConfig = null;
    adding = false;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  function clearCreProperties(form) {
    Array.prototype.slice.call(form.querySelectorAll('[data-d1-cre-prop]')).forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }

  function addHiddenProp(form, key, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[_d1_cre_' + key + ']';
    input.value = value == null ? '' : String(value);
    input.setAttribute('data-d1-cre-prop', 'true');
    form.appendChild(input);
  }

  function stampProperties(form, input, result) {
    clearCreProperties(form);
    addHiddenProp(form, 'eligibility', result.code);
    addHiddenProp(form, 'family', input.family);
    addHiddenProp(form, 'retailer', input.retailer || '');
    addHiddenProp(form, 'not_activated', input.notActivated ? 'true' : 'false');
    if (input.notActivated) {
      addHiddenProp(form, 'activation_date', '');
      addHiddenProp(form, 'days', '');
    } else {
      addHiddenProp(form, 'activation_date', input.activationDate || '');
      addHiddenProp(form, 'days', String(daysBetween(input.activationDate)));
    }
    if (result.needsBeyond48) {
      addHiddenProp(form, 'email', input.email);
      addHiddenProp(form, 'beyond48', 'true');
    }
  }

  function cartSections() {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || typeof cart.getSectionsToRender !== 'function') return null;
    return cart.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  function creProperties(input, result) {
    var props = {
      _d1_cre_eligibility: result.code,
      _d1_cre_family: input.family,
      _d1_cre_retailer: input.retailer || '',
      _d1_cre_not_activated: input.notActivated ? 'true' : 'false',
      _d1_cre_activation_date: input.notActivated ? '' : input.activationDate || '',
      _d1_cre_days: input.notActivated ? '' : String(daysBetween(input.activationDate)),
    };
    if (result.needsBeyond48) {
      props._d1_cre_email = input.email;
      props._d1_cre_beyond48 = 'true';
    }
    return props;
  }

  function itemsFromPending() {
    if (
      pendingButton &&
      window.D1AccessoryAtc &&
      typeof window.D1AccessoryAtc.itemsFromButton === 'function'
    ) {
      var fromBtn = window.D1AccessoryAtc.itemsFromButton(pendingButton);
      if (fromBtn && fromBtn.length) return fromBtn;
    }
    var comboApi = window.D1CardVariantPills;
    if (comboApi && pendingForm && typeof comboApi.comboCartItems === 'function') {
      return comboApi.comboCartItems(pendingForm) || [];
    }
    return [];
  }

  function postItems(items) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var sections = cartSections();
    var payload = { items: items };
    if (sections && sections.length) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json();
    });
  }

  function addPendingToCart(input, result) {
    var extra = creProperties(input, result);
    var items = itemsFromPending();
    if (items.length) {
      items.forEach(function (item) {
        item.properties = Object.assign({}, item.properties || {}, extra);
      });
      return postItems(items);
    }
    if (!pendingForm) return Promise.reject(new Error('Could not add to cart'));
    stampProperties(pendingForm, input, result);
    return addFormToCart(pendingForm);
  }

  function addFormToCart(form) {
    var comboApi = window.D1CardVariantPills;
    var comboItems =
      comboApi && typeof comboApi.comboCartItems === 'function' ? comboApi.comboCartItems(form) : [];
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var sections = cartSections();

    if (comboItems.length >= 2) {
      var payload = { items: comboItems };
      if (sections && sections.length) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }
      return fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      }).then(function (res) {
        return res.json();
      });
    }

    var formData = new FormData(form);
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    if (sections && sections.length) {
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;
    return fetch(url, config).then(function (res) {
      return res.json();
    });
  }

  function showCart(response) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && typeof cart.renderContents === 'function') {
      cart.renderContents(response);
    } else if (!cart) {
      window.location = (window.routes && window.routes.cart_url) || '/cart';
    }
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'care-refresh-eligibility',
        cartData: response,
      });
    }
  }

  function showDone(input, emailed) {
    var formEl = qs('[data-cre-form]');
    var doneEl = qs('[data-cre-done]');
    var copyEl = qs('[data-cre-done-copy]');
    var linkEl = qs('[data-cre-done-link]');
    if (modal) modal.classList.add('is-done');
    if (formEl) formEl.classList.add('is-hidden');
    if (doneEl) doneEl.classList.add('is-visible');
    var sheet = modal && modal.querySelector('.cre-modal__content');
    if (sheet) sheet.scrollTop = 0;
    if (copyEl) {
      var template = emailed
        ? modalLabel('data-done-sent')
        : modalLabel('data-done-fallback');
      copyEl.textContent = String(template || '').replace(/%email%/g, input.email);
    }
    if (linkEl) {
      var url =
        (pendingConfig && pendingConfig.beyond48Url) ||
        linkEl.getAttribute('href') ||
        '/pages/care-refresh-beyond-48-hours';
      linkEl.setAttribute('href', url);
    }
  }

  function sendFormInvite(input) {
    var url =
      (modal && modal.getAttribute('data-form-invite-url')) ||
      'https://d1x.d1store.app/api/public/care-refresh-beyond-48/form-invites';
    var honeypot = qs('[data-cre-honeypot]');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        honeypot: honeypot ? honeypot.value : '',
        customerEmail: input.email,
        productTitle: pendingConfig && pendingConfig.title ? pendingConfig.title : null,
        family: input.family,
        activationDate: input.notActivated ? null : input.activationDate,
        retailer: input.retailer,
      }),
    })
      .then(function (res) {
        return res.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function onEligSubmit(e) {
    e.preventDefault();
    if ((!pendingForm && !pendingButton) || adding) return;
    var input = currentInput();
    var result = evaluateEligibility(input);
    var ready = !!(input.retailer && (input.notActivated || input.activationDate));
    if (!result.ok || !ready) return;
    if (result.needsBeyond48 && !isValidEmail(input.email)) return;

    adding = true;
    renderStatus();
    if (pendingForm) stampProperties(pendingForm, input, result);
    addPendingToCart(input, result)
      .then(function (response) {
        if (response && response.status) {
          throw new Error(response.description || response.message || 'Could not add to cart');
        }
        markPendingAdded();
        if (result.needsBeyond48) {
          return sendFormInvite(input).then(function (emailed) {
            showDone(input, emailed);
            showCart(response);
          });
        }
        closeModal();
        showCart(response);
      })
      .catch(function (err) {
        adding = false;
        renderStatus();
        var statusEl = qs('[data-cre-status]');
        var statusTitle = qs('[data-cre-status-title]');
        var statusCopy = qs('[data-cre-status-copy]');
        if (statusEl) {
          statusEl.className = 'cre-status is-visible is-block';
        }
        if (statusTitle) statusTitle.textContent = 'Couldn’t add to cart';
        if (statusCopy) statusCopy.textContent = err && err.message ? err.message : 'Please try again.';
      });
  }

  function markPendingAdded() {
    if (pendingButton && window.D1AccessoryAtc && typeof window.D1AccessoryAtc.markInCart === 'function') {
      window.D1AccessoryAtc.markInCart(pendingButton, { justAdded: true });
    }
  }

  function onCardAtcClick(e) {
    if (!e || !e.target || !e.target.closest) return;
    if (e.target.closest('#CareRefreshEligibilityModal, [data-cre-form]')) return;
    var btn = e.target.closest('.card__atc-btn[data-variant-id]');
    if (!btn || btn.disabled || btn.tagName !== 'BUTTON') return;
    var card = btn.closest('.card, .card-wrapper');
    var form = card
      ? card.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')
      : null;
    var config = parseConfig(form) || configFromCard(card);
    if (!config) return;
    config.planNote = planNoteFromContext(card, form);
    e.preventDefault();
    e.stopImmediatePropagation();
    pendingButton = btn;
    openModal(form, config);
  }

  function onProductFormSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.hasAttribute('data-cre-form')) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
    var config = parseConfig(form);
    if (!config) return;
    config.planNote = planNoteFromContext(form.closest('product-info, .product, .card, .card-wrapper'), form);
    e.preventDefault();
    e.stopImmediatePropagation();
    openModal(form, config);
  }

  function onKeydown(e) {
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
    }
  }

  function bindModal() {
    modal = document.getElementById('CareRefreshEligibilityModal');
    if (!modal) return;
    modal.querySelectorAll('[data-cre-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    var notActivatedBtn = choiceBtn();
    if (notActivatedBtn) {
      notActivatedBtn.addEventListener('click', function () {
        setNotActivated(!isNotActivated());
        renderStatus();
      });
    }
    ['#cre-activation-date', '#cre-retailer', '#cre-customer-email'].forEach(function (sel) {
      var el = qs(sel);
      if (!el) return;
      el.addEventListener('input', renderStatus);
      el.addEventListener('change', renderStatus);
    });
    var proof = qs('[data-cre-proof]');
    var upload = qs('[data-cre-upload]');
    var uploadTitle = qs('[data-cre-upload-title]');
    if (proof) {
      proof.addEventListener('change', function () {
        var file = this.files && this.files[0];
        if (upload) upload.classList.toggle('is-filled', !!file);
        if (uploadTitle) {
          uploadTitle.textContent = file
            ? file.name
            : uploadTitle.getAttribute('data-default-title') || 'Upload receipt';
        }
      });
    }
    var formEl = qs('[data-cre-form]');
    if (formEl) formEl.addEventListener('submit', onEligSubmit);
    document.addEventListener('keydown', onKeydown);
  }

  function bind() {
    bindModal();
    document.addEventListener('submit', onProductFormSubmit, true);
    document.addEventListener('click', onCardAtcClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
